import React from 'react';
import PropTypes from 'prop-types';
import P from '@deliveroo/consumer-component-library/components/P';

import styles from './styles.scss';

/**
 * A section of more detailed About content for Brand Landing Pages
 */
export default function LandingPageAboutSection({ content, backgroundImage }) {
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        {Array.isArray(content) &&
          content.map((paragraph) => (
            <P key={paragraph} adjacentVerticalSpacing="medium" color="grey">
              {paragraph}
            </P>
          ))}
      </div>
      <div
        className={styles.image}
        style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
      />
    </div>
  );
}

LandingPageAboutSection.propTypes = {
  /**
   * An array of paragraphs of text to display
   */
  content: PropTypes.arrayOf(PropTypes.string).isRequired,

  /**
   * An optional background image to override the default with.
   */
  backgroundImage: PropTypes.string,
};

LandingPageAboutSection.defaultProps = {
  backgroundImage: undefined,
};
